// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yuBws,.VzA0R,.JFn_I{color:#f38077;display:block;font-size:12px;line-height:1.84}.yuBws[for],[for].VzA0R,[for].JFn_I{cursor:pointer}.PYjie{bottom:-16px;line-height:14px;margin:0;position:absolute;right:0;text-align:right;white-space:nowrap}.VzA0R,.JFn_I{margin-bottom:10px;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `yuBws`,
	"globalErrorMessage": `VzA0R`,
	"root": `JFn_I`,
	"error_amount": `PYjie`
};
module.exports = ___CSS_LOADER_EXPORT___;
